<template>
  <div class="homePage">
    <div class="hdfix"
         :class="{hd2:topMsg.v}">
      <div class="header">
        <template v-if="mhDbShHotel">
          <span @click='goSearch'>{{ homeUserInfo.hotelName }}<i class="iconfont icon-xia"></i></span>
        </template>
        <template v-else>
          <span>{{ homeUserInfo.hotelName }}</span>
        </template>

        <div class="right"
             @click="getbarcode"><i class="iconfont icon-saoma"></i></div>
        <div class="topMsg"
             v-if="topMsg.v">
          <a v-if="topMsg.url && topMsg.url.indexOf('http') == 0"
             @click="openUrl(topMsg.url)">{{ topMsg.msg | flength }}
          </a>
          <router-link :to="topMsg.url"
                       v-else-if="topMsg.url">{{ topMsg.msg | flength }}>>
          </router-link>
          <template v-else>{{ topMsg.msg | flength }}</template>
          <div class="cleartext"
               @click="closeTopMsg">
            <i class="iconfont icon-cuowu"></i>
          </div>
        </div>
      </div>
    </div>

    <mt-loadmore :top-method="loadTop"
                 :topDistance="50"
                 :maxDistance="130"
                 @top-status-change="handleTopChange"
                 :top-status.sync="topStatus"
                 ref="loadmore">
      <div class="myList">
        <my-list></my-list>
      </div>
      <template v-if="mhDbReven">
        <div :class="{'isLiCheng': !isLiCheng}">
          <lichengHomeData ref="lichengHomeData"></lichengHomeData>
        </div>
        <div :class="{'isLiCheng': isLiCheng}">
          <homeData  ref="homeData"></homeData>
        </div>
        <div slot="top"
             class="mint-loadmore-top">
          <span v-show="topStatus !== 'loading'"
                :class="{ 'rotate': topStatus === 'drop' }"> ↓ {{ $t('index_refresh') }}</span>
          <span v-show="topStatus === 'loading'">Loading...</span>
        </div>
      </template>
    </mt-loadmore>
    <foot-nav sta='1'></foot-nav>
  </div>
</template>
<script>
import myList from '../common/myList';
import footNav from '../common/footNav';
import homeData from '../common/homeData';
import lichengHomeData from '../common/licheng/HomeData';
import {Toast, MessageBox} from 'mint-ui';
import _ from 'lodash';
import watermark from 'watermark-dom'

export default {
  data() {
    let LoginOptionStr = localStorage.getItem('LoginOption')
    let LoginOption = JSON.parse(LoginOptionStr || "{}")
    var currentLichengCode = localStorage.getItem('currentLichengCode') || ''
    return {
      useHotelCode: currentLichengCode || LoginOption.hotelCode || '',
      topStatus: '',
      homeUserInfo: {},
      topMsg: {v: false, msg: '', type: 'msg', link: ''},
      isJingJiang: localStorage.getItem('isJingJiang') == 'yes',
      isLiCheng: false,
      listened: false,

      // 新权限控制
      mhDbReven: false,
      mhDbShHotel: false,
    };
  },
  mounted() {
    this.getHomeUserInfo();
    var that = this;
    window.showTopMsg = this.showTopMsg;
    window.setTimeout(function () {
      that.versionMsg();
    }, 2000);
    //使跳回首页页面显示在顶部，而不是中间段
    document.getElementsByClassName('homePage')[0].scrollTop = 0;
    this.initJingJiangListen()

    if (this.$route.query.gurl != null) {
      if (this.$isApp) {
        var A = plus.webview.getLaunchWebview();
        this.openUrl(this.$route.query.gurl);
      }
    }

    // 新权限控制
    this.mhDbReven = this.$hasPermission('mh!db!reven', true)
    this.mhDbShHotel = this.$hasPermission('mh!db!sh!hotel', true)
    this.getisLiCheng()
    this.getPersonInfo()
  },
  methods: {
    getPersonInfo () {
      this.$http.post("/mobilepmsapi/sys/getUserInfo").then(res => {
        if (res.data.result == 0) {
          var obj = res.data.retVal;
          if(obj.hotelGroupCode == 'HYMSG'){
            watermark.load({
              watermark_txt: (obj.code || '') + '-' + (obj.name || ''),
              watermark_fontsize:'12px',          //水印字体大小
            })
          }
        }
      });
    },
    getisLiCheng() {
      const self = this
      this.$http.post("/mobilepmsapi/sysOptions/findHotelIsLiCheng", {
        hotelCode: this.useHotelCode || '',
        noErrorToast: true
      }).then(res => {
        if (res.data.result == 0) {
          let retVal = res.data.retVal || "false";
          self.isLiCheng = retVal == 'true'
          localStorage.setItem('isLiCheng', (retVal == 'true') ? 'yes' : 'no') // 房情筛选楼栋
          if(retVal == 'true'){
            this.getHomeUserInfo()
          }
        }
      });
    },
    initJingJiangListen() {
      var that = this;
      if (this.isJingJiang && !this.listened) {
        this.listened = true
        document.addEventListener('resume', function () {
          //从后台切换到前台
          // let arg = 'mihotel://beginTime=2020-0-18 00:00&endTime=2020-05-19 12:00&roomNo=0000&page=fangT&chainNo=1234'
          let arg = plus.runtime.arguments
          let lastInvokeId = localStorage.getItem('lastInvokeId') || ''
          // alert('index被唤醒，参数是：' + arg + ', listened'+ that.listened + ','+ that.$route.name + ',' + lastInvokeId)
          if (arg != '' && that.$route.name == 'index') {
            try {
              let temp = arg.split('//') || []
              let str = temp[1] || ''
              if (str) {
                let aj = that.parseQueryString(str)
                let roomNo = aj.roomNo || ''
                // alert('index lastInvokeId: ' + lastInvokeId + ', ajId: ' + aj.id)
                if (lastInvokeId && lastInvokeId == aj.id) {
                  // that.msg2('重复读卡')
                } else {
                  setTimeout(() => {
                    localStorage.setItem('lastInvokeId', aj.id)
                  }, 500)
                  if (roomNo) {
                    if (roomNo == '0') {
                      that.msg2(that.$t('jj_empty_card'))
                    } else {
                      that.$router.push('/fangT?type=jingjiang&roomNo=' + roomNo + '&beginTime=' + aj.beginTime + '&endTime=' + aj.endTime);
                    }
                  } else {
                    // that.msg2(this.$t('jj_empty_card'))
                  }
                }
              }
              // 处理JSON对象aj
            } catch (e) {
              // plus.runtime.arguments = ''
              // 若传入的参数不是JSON格式字符，需处理异常情况
            }

          }
        }, false);
      }
    },

    getHomeUserInfo() {
      this.$http.get('/mobilepmsapi/sys/getHomeUserInfo').then(res => {
        if (res.data.result == 0) {
          this.homeUserInfo = res.data.retVal;
          this.disHomeData();
          localStorage.setItem("homeUserInfo", JSON.stringify(this.homeUserInfo))
        }
      });
    },
    // getHomeUserInfo() {
    //   var switchHotelInfo = localStorage.getItem('switchHotelInfo') || "{}"
    //   var info = JSON.parse(switchHotelInfo) || {}
    //   this.$http.post('/mobilepmsapi/sys/getHomeUserInfoPro', info).then(res => {
    //     if (res.data.result == 0) {
    //       this.homeUserInfo = res.data.retVal;
    //       this.disHomeData();
    //     }
    //   });
    // },
    openUrl(url) {
      var A = plus.webview.getLaunchWebview();
      A.evalJS('openUrl("' + url + '")');
    },
    disHomeData() {
      if (this.homeUserInfo.bHomeData && this.$refs.homeData) {

        if(this.isLiCheng){
          this.$refs.lichengHomeData.getData();
        } else {
          this.$refs.homeData.getData();
        }
      }
    },
    versionMsg() {
      if (this.$isApp) {
        this.waitReady();
      } else {
        if (
          localStorage.getItem('version') == null ||
          localStorage.getItem('version') != this.pversion
        ) {
          localStorage.setItem('version', this.pversion);
          this.showTopMsg(
            this.pversion + this.$t('index_new_version'),
            'msg',
            '/versionDetail?redirect=/'
          );
        }
      }
    },
    plusReady() {
      var c = plus.storage;
      if (
        c.getItem('version') == null ||
        c.getItem('version') != this.pversion
      ) {
        c.setItem('version', this.pversion);
        this.showTopMsg(
          this.pversion + this.$t('index_new_version'),
          'msg',
          '/versionDetail?redirect=/'
        );
      } else {
        var A = plus.webview.getLaunchWebview();
        A.evalJS('disPushMsg()');
      }
      this.setCliInfo()
    },
    setCliInfo() {
      this.$http.get("/mobilepmsapi/sysOptions/activePush?cid=" + plus.push.getClientInfo().clientid + "&device=" + plus.os.name, {
        noErrorToast: true
      }).then(res => {
      });
    },
    waitReady() {
      if (window.plus) {
        this.plusReady();
      } else {
        document.addEventListener('plusReady', this.plusReady, false);
      }
    },
    showTopMsg(msg, type, url) {
      this.topMsg = {
        msg: msg,
        v: true,
        type: type,
        url: url && url.indexOf('#') == 0 ? url.substr(1) : url
      };
    },
    closeTopMsg() {
      this.topMsg.v = false;
      if (this.topMsg.type == 'push') {
        var A = plus.webview.getLaunchWebview();
        A.evalJS('clearPushMsg()');
      } else {
        if (this.$isApp) {
          var A = plus.webview.getLaunchWebview();
          A.evalJS('disPushMsg()');
        }
      }
    },

    getbarcode: _.debounce(function () {
      var A = plus.webview.getLaunchWebview();
      var that = this;
      window.barback = function (a) {
        that.$http
          .post('/mobilepmsapi/sys/getScanResult', {data: a})
          .then(res => {
            if (res.data.result == 0) {
              var d = res.data.retVal;
              //console.log(d.data);
              if (d.type == 'login') {
                A.evalJS('openUrl("' + d.data + '")');
              } else if (d.type == 'url') {
                A.evalJS('openUrl("' + d.data + '")');
              } else if (d.type == 'coupon') {
                that.$router.push('/CouponUse?couponNo=' + d.data);
              } else {
                MessageBox.confirm(d.data, '', {
                  confirmButtonText: that.$t('Copy'),
                  cancelButtonText: that.$t('MessageBox_cancelButtonText')
                }).then(action => {
                  A.evalJS('copy("' + d.data + '")');
                  that.msg2(that.$t('CopySuccess'));
                });
              }
            } else {
              that.msg2(res.data.msg);
            }
          });
      };
      A.evalJS('getcardCode()');
    }, 500, true),

    goSearch() {
      this.$router.push('search');
    },
    handleTopChange: function (status) {
      this.topStatus = status;
    },
    loadTop() {
      this.disHomeData();
      this.$refs.loadmore.onTopLoaded();
    }
  },
  filters: {
    flength(value) {
      return value.length > 30 ? value.substr(0, 28) + '.. ' : value;
    }
  },
  components: {
    myList,
    footNav,
    homeData,
    lichengHomeData
  }
};
</script>
<style lang='less'
       scoped>
.homePage {
  overflow: auto;

  .isLiCheng {
    position: fixed;
    top: -100000px;
    left: -100000px;
  }
  .hdfix {
    height: 1.066667rem;

    .header {
      height: 1.066667rem;
      background-color: #393c41;
      position: fixed;
      width: 100%;
      z-index: 2;

      .right {
        position: absolute;
        right: 0.3rem;
        top: 0;
        color: #fff;

        i {
          font-size: 0.6rem;
          line-height: 1.066667rem;
        }

        /* div{font-size:0.32rem;transform:scale(0.6);position: absolute;top:0.6rem;left:0.14rem}*/
      }

      span {
        font-size: 0.4rem;
        width: 75%;
        display: block;
        margin: 0 auto;
        text-align: center;
        color: #fff;
        line-height: 1.066667rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .hd2 {
    height: 1.94rem;
  }

  .topMsg {
    color: #6c6500;
    height: 0.9rem;
    width: 100%;
    background: #f6ef8b;
    line-height: 0.9rem;
    padding-left: 0.3rem;
    margin-top: -2px;

    a {
      color: #6c6500;
    }

    .cleartext {
      float: right;
      padding-right: 0.3rem;
      margin-top: -0.01rem;

      i.icon-cuowu {
        line-height: 0.32rem;
        background-color: #cabc00;
        border-radius: 50%;
        font-size: 0.32rem;
        text-align: center;
        color: #fff;
        padding: 0.13rem;
        -webkit-transform-origin-x: 0;
        transform: scale(0.6);
        -webkit-transform: scale(0.6);
        width: 0.32rem;
        display: inline-block;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// index.vue?4e1d546b